import React from 'react';
import { Datagrid, FunctionField, TextField, usePermissions, useRecordContext, SingleFieldList, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import CustomList from '@/components/global/list/CustomList.jsx';
import { CustomListNoResults } from '@/components/global/list/CustomListNoResults.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import CustomShowModalButton from '@/components/global/buttons/CustomShowModalButton.jsx';
import CustomMorePopover from '@/components/global/buttons/CustomMorePopover.jsx';
import CustomChipField from '@/components/global/fields/CustomChipField.jsx';
import { useDrawer } from '@/composables/useDrawer';
import { TagsArrayField } from '@/components/tagCategory/TagsArrayField.jsx';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

const MoreActionsPopover = () => {
    const record = useRecordContext();
    const { openDrawer } = useDrawer();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const canShow = canViewDetails('tag-category', permissions);

    if (!record || (!canShow && !permissions.isAdmin)) return null;

    return (
        <CustomMorePopover record={record}>
            {canShow && (
                <CustomShowModalButton label={translate('resources.tagCategory.labels.showTags')} onOpen={() => openDrawer(record.id, 'tag-category-show')} />
            )}
            {permissions.isAdmin && (
                <CustomEditModalButton label={translate('resources.tagCategory.labels.editTags')} onOpen={() => openDrawer(record.id, 'tag-category-edit')} />
            )}
        </CustomMorePopover>
    );
};

export const TagCategoryList = () => {
    const { isLoading, permissions } = usePermissions();
    const translate = useTranslate();
    const { openDrawer } = useDrawer();
    const canShow = canViewDetails('tag-category', permissions);

    if (isLoading) return null;

    return (
        <CustomList filters={[]} paginationClassName='pagination-rounded' title={translate('menu.tagManagement')}>
            <Datagrid
                className='tags-layout'
                bulkActionButtons={false}
                rowClick={
                    canShow
                        ? id => {
                              openDrawer(id, 'tag-category-show');
                              return false;
                          }
                        : false
                }
                empty={<CustomListNoResults />}
            >
                <TextField source='name' className='tag-header' label={translate('resources.tagCategory.fields.namePl')} />
                <TagsArrayField source='tags' label={translate('resources.product.fields.tags')}>
                    <SingleFieldList linkType={false} className='tag-list'>
                        <CustomChipField shades={true} />
                    </SingleFieldList>
                </TagsArrayField>
                <TextField source='nameEn' className='tag-header' label={translate('resources.tagCategory.fields.nameEn')} />
                <TagsArrayField source='tags' label={translate('resources.product.fields.tags')}>
                    <SingleFieldList linkType={false} className='tag-list'>
                        <CustomChipField source='nameEn' shades={true} />
                    </SingleFieldList>
                </TagsArrayField>
                {canShow || permissions.isAdmin ? (
                    <FunctionField
                        label={translate('common.options')}
                        render={() => (
                            <Box onClick={event => event.stopPropagation()}>
                                <MoreActionsPopover />
                            </Box>
                        )}
                    />
                ) : (
                    <></>
                )}
            </Datagrid>
        </CustomList>
    );
};
